import React from 'react';
import '../styles/Hero.css'; // we'll create this CSS file too

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Welcome to Bularis Tech</h1>
        <p>Your trusted partner for domain, hosting, web, mobile, and e-commerce solutions.</p>
        <a href="/contact" className="hero-button">Get Started</a>
      </div>
    </section>
  );
}

export default Hero;
